module.exports = __webpack_public_path__ + "img/380.2ab75ab6.jpg";